import React from 'react';
import { noop } from 'lodash';
import { FRIEND_REQUESTS, FRIEND } from 'app/constants/friendStatusTypes';
import FriendRequestDetails from './FriendRequestDetails';
import FriendDetails from './FriendDetails';
import FriendMaybeDetails from './FriendMaybeDetails';

type Props = {
  friend: FriendRequest | Friend | User,
  onClick?: (friend: FriendRequest | Friend | User) => void,
};

class FriendOpenCard extends React.Component {
  props: Props;

  static defaultProps = {
    onClick: noop,
  };

  render() {
    const { onClick, friend } = this.props;
    if (FRIEND_REQUESTS.includes(friend.status)) {
      // must be a request
      return <FriendRequestDetails request={friend} onClick={() => onClick(friend)} />;
    } else if (friend.status === FRIEND) {
      // must be a friend
      return <FriendDetails friend={friend} onClick={() => onClick(friend)} />;
    }
    // isn't a friend yet
    return <FriendMaybeDetails searchFriend={friend} onClick={() => onClick(friend)} />;
  }
}

export default FriendOpenCard;
